var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image",
    d: "M14.5,0H1.5A1.447,1.447,0,0,1,.438-.437,1.447,1.447,0,0,1,0-1.5v-9a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-12h13a1.447,1.447,0,0,1,1.063.438A1.447,1.447,0,0,1,16-10.5v9a1.447,1.447,0,0,1-.437,1.063A1.447,1.447,0,0,1,14.5,0ZM4.719-9.719A1.61,1.61,0,0,0,3.5-10.25a1.684,1.684,0,0,0-1.234.516A1.684,1.684,0,0,0,1.75-8.5a1.684,1.684,0,0,0,.516,1.234A1.684,1.684,0,0,0,3.5-6.75a1.684,1.684,0,0,0,1.234-.516A1.684,1.684,0,0,0,5.25-8.5,1.61,1.61,0,0,0,4.719-9.719ZM2-2H14V-5.5L11.25-8.25a.312.312,0,0,0-.5,0L6.5-4,4.75-5.75a.313.313,0,0,0-.5,0L2-3.5Z",
    transform: "translate(0 12)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.d7e816dd808208ad65fb6e97f2117170.svg";
export { ForwardRef as ReactComponent };